var _Circle, _Path, _G, _Circle2, _Path2, _G2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path, G, Rect } from "react-native-svg";
var SvgPinHybrid = function SvgPinHybrid(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    viewBox: "2.5 1.5 39 39"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 22,
    cy: 21,
    r: 18,
    fill: "#FFFFFF",
    stroke: "#0284C7",
    strokeWidth: 2.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#16A34A",
    strokeWidth: 2.5,
    d: "M22 3a18 18 0 0 0 0 36"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 8.5,
    height: 15,
    x: 11,
    y: 14,
    fill: "#15803D",
    stroke: "#166534",
    strokeWidth: 1,
    rx: 2
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#86EFAC",
    d: "M15.2 25s-2-2-2-3.2c0-1 .9-1.8 2-1.8s2 .8 2 1.8c0 1.2-2 3.2-2 3.2"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 5.5,
    height: 2.5,
    x: 12.5,
    y: 16.5,
    fill: "#DCFCE7",
    rx: 0.5
  }))), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 22,
    cy: 16.5,
    r: 2.8,
    fill: "#F0FDF4",
    stroke: "#16A34A",
    strokeWidth: 1
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#16A34A",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M22 14.5v4m-2-2h4"
  })), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 8.5,
    height: 15,
    x: 24.5,
    y: 14,
    fill: "#0284C7",
    stroke: "#0369A1",
    strokeWidth: 1,
    rx: 2
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#BAE6FD",
    d: "m29.5 19-2.7 5h2.4L28 28l4.2-4.8h-2.4l.7-4.2Z"
  }))));
};
export default SvgPinHybrid;